import { createReducer } from "@reduxjs/toolkit"
import * as orderTrackingActions from '../actions/orderTracking'
import { APIData, APIStatus } from "../axiosConfiguration"
import { OrderTrackingData, OrderTrackingDocuments } from "../type/orderTracking"

type orderTrackingState = {
    orderTracking: APIData<OrderTrackingData>,
    orderTrackingDocumentData: APIData<OrderTrackingDocuments>
}

const initialState: orderTrackingState = {
    orderTracking: { status: APIStatus.IDLE },
    orderTrackingDocumentData: { status: APIStatus.IDLE },
}

export default createReducer(initialState, (builder) => {
    builder
        .addCase(orderTrackingActions.getOrderTrackingList.fulfilled, (state, action) => {
            state.orderTracking.status = APIStatus.FULFILLED
            state.orderTracking.data = action.payload
        })
        .addCase(orderTrackingActions.getOrderTrackingList.rejected , (state, action) => {
            state.orderTracking.status = APIStatus.REJECTED
            state.orderTracking.error = action.payload
        })
        .addCase(orderTrackingActions.getOrderTrackingList.pending, (state, action) => {
            state.orderTracking.status = APIStatus.PENDING
        })
    
    builder
        .addCase(orderTrackingActions.getOrderTrackingDocument.fulfilled, (state, action) => {
            state.orderTrackingDocumentData.status = APIStatus.FULFILLED
            state.orderTrackingDocumentData.data = action.payload
        })
        .addCase(orderTrackingActions.getOrderTrackingDocument.rejected , (state, action) => {
            state.orderTrackingDocumentData.status = APIStatus.REJECTED
            state.orderTrackingDocumentData.error = action.payload
        })
        .addCase(orderTrackingActions.getOrderTrackingDocument.pending, (state, action) => {
            state.orderTrackingDocumentData.status = APIStatus.PENDING
        })
    
})